import { IUntypedCommand, Topics } from '@zaplify/common';
import { CreateProspectDataDto } from '../prospects';

export class CreatePropsectsCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userOrganizationId: string, readonly prospectsData: CreateProspectDataDto[]) {
        super();
    }
}
